// getters : 각 Components의 계산된 속성(computed)의 공통 사용 정의
//           하위 모듈의 getters를 불러오기 위해서는 특이하게 this.$store.getters["경로명/함수명"]; 을 사용
const getters = {
  homeData: state => state.home.homeData,
  userData: state => state.home.userData,
  isHomeLoading: state => state.home.isLoading
};

export default getters;
